'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CalendarFull = require('./CalendarFull');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CalendarFull).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CalendarFull/index.js
// module id = 1128
// module chunks = 1